import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Event } from '../../../../models/calendar';
import { DEFAULT_TIMEZONE } from '../../../../services/calendar.service';
import {
  getCalendarState,
  MarketDrawerRootReducerState
} from '../../../../state/reducer';
import {
  CalendarHideEventAction,
  CalendarToggleFullscreenAction
} from '../../../../state/calendar/actions';
import momentTz from 'moment-timezone';

@Component({
  selector: 'muni-gameday-event',
  templateUrl: './event.template.html',
  styleUrls: ['./event.styles.scss']
})
export class EventComponent {
  @Input()
  event: Event;

  public readonly fullscreen: Observable<boolean> = this.store.pipe(
    map(state => getCalendarState(state).fullscreen)
  );

  constructor(private store: Store<MarketDrawerRootReducerState>) {}

  public closeEvent(): void {
    this.store.dispatch(new CalendarHideEventAction());
  }

  public toggleFullscreen(): void {
    this.store.dispatch(new CalendarToggleFullscreenAction());
  }

  public releaseString(): string {
    return (
      momentTz(this.event.releasedAt)
        .tz(DEFAULT_TIMEZONE)
        .format('M/D/YYYY h:mm A') + ' ET'
    );
  }
}
